module.exports = __webpack_public_path__ + "img/coupon_bg_2.1010ed49.png";